import { ColType, PaginatedTable } from 'chakra-paginated-table'
import React, { useState } from 'react'
import { commonPaginationProps, IInitState, ISchema, TABLE_PAGE_SIZE } from '../definitions'
import CellDisplay from './CellDisplay'
interface IProps {
  processedData: Omit<IInitState, 'errorState'>
}

const cols: (props: {
  columns: string[]
  fixes: ISchema[]
  page: number
}) => ColType<ISchema & { lineNo: string }>[] = ({ fixes, columns, page }) => {
  return ['lineNo', ...columns].map((eachCol) => {
    const width = eachCol.length * 15
    return {
      key: eachCol,
      title: eachCol,
      align: 'center',
      dataKey: eachCol as keyof ISchema,
      render(value: string, _, index) {
        const recordIndexInSchema = (page - 1) * TABLE_PAGE_SIZE + index!

        return eachCol === 'lineNo' ? (
          value
        ) : (
          <CellDisplay
            width={width}
            cellData={value}
            schemaFix={fixes[recordIndexInSchema]?.[eachCol as unknown as keyof ISchema]}
          />
        )
      },
    }
  })
}

function FixesTable({ processedData }: IProps) {
  const [page, setpage] = useState(1)
  const { columns, dataSource, schemaFixes } = processedData

  return (
    <PaginatedTable
      dataSource={dataSource}
      columns={cols({ columns: columns, fixes: schemaFixes, page })}
      rowKey={(_, i) => i}
      pagination={{
        page,
        pageSize: TABLE_PAGE_SIZE,
        total: dataSource.length,
        onchange(newPage) {
          setpage(newPage)
        },
        ...commonPaginationProps,
      }}
      TableProps={{
        maxWidth: '80vw',
        overflow: 'auto',
      }}
      THeadProps={{
        bg: 'gray.100',
      }}
    />
  )
}

export default FixesTable
